var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4733_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.15625 10.3125H36.0938C38.9383 10.3125 41.25 12.6242 41.25 15.4688V25.7812C41.25 28.6258 38.9383 30.9375 36.0938 30.9375H17.1875L8.59375 37.8125V30.9375H5.15625C2.31172 30.9375 0 28.6258 0 25.7812V15.4688C0 12.6242 2.31172 10.3125 5.15625 10.3125Z",
    stroke: "#EA3323",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9688 42.1094C45.3418 42.1094 47.2656 40.1856 47.2656 37.8125C47.2656 35.4394 45.3418 33.5156 42.9688 33.5156C40.5957 33.5156 38.6719 35.4394 38.6719 37.8125C38.6719 40.1856 40.5957 42.1094 42.9688 42.1094Z",
    stroke: "#EA3323",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6719 46.4062C38.6719 43.5617 40.9836 41.25 43.8281 41.25C46.6727 41.25 48.9844 43.5617 48.9844 46.4062",
    stroke: "#EA3323",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2188 42.9688C31.1172 42.9688 32.6562 41.4297 32.6562 39.5312C32.6562 37.6328 31.1172 36.0938 29.2188 36.0938C27.3203 36.0938 25.7812 37.6328 25.7812 39.5312C25.7812 41.4297 27.3203 42.9688 29.2188 42.9688Z",
    stroke: "#EA3323",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7812 46.4062C25.7812 44.507 27.3195 42.9688 29.2188 42.9688C31.118 42.9688 32.6562 44.507 32.6562 46.4062",
    stroke: "#EA3323",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4733_112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.0a2a550854edd26e89214350e982229b.svg";
export { ForwardRef as ReactComponent };